<template>
  <div class="tes-card pa-7 fill-weight">
    <h1 class="tes-card__title">{{$t('pages.historySpdDetails.title')}}</h1>

    <v-row no-gutters class="my-4">
      <v-col cols="9">
        <div class="d-flex flex-nowrap">
          <span class="mr-3 fs-18 d-inline-block mt-1" :class="currentLocale === 'ru' ? 'helvetica-medium' : 'rubik-medium'"
            >{{$t('personalAccount')}}:</span
          >
          <personal-account-select
            :onlyIsOwner="false"
            :disabled="loading"
            class="d-inline-block"
          ></personal-account-select>
        </div>
      </v-col>
      <div class="flex-grow-1"></div>
      <v-col cols="3" class="text-right tes-green-text fs-20" :class="currentLocale === 'ru' ? 'helvetica-medium' : 'rubik-medium'">
        <div>{{ getDateToLocaleString(month, year) | capitalize }}</div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <loader-wrapper
          :loading="loading"
          :opacity="0.8"
          :showNoDataText="!recieptDocument.length"
        >
          <v-table-wrapper
            v-if="windowSize.x > 768"
            :headers="headers"
            :items="recieptDocument"
            class="tes-table-wrapper"
          ></v-table-wrapper>

          <v-data-table
            v-else
            :items="recieptDocument"
            :headers="headers"
            class="tes-table-wrapper"
          >
            <template v-slot:no-data>{{ "" }}</template>
          </v-data-table>
        </loader-wrapper>
      </v-col>
    </v-row>
    <v-row no-gutters class="mt-4 mr-8">
      <v-col
        cols="9"
        class="text-right tes-green-text helvetica-medium fs-20"
      ></v-col>
      <v-col cols="3" class="text-right tes-green-text fs-16" :class="currentLocale === 'ru' ? 'helvetica-medium' : 'rubik-medium'">
        <span>{{$t('pages.historySpdDetails.total')}}: </span>
        <span>{{
          Number(Number.parseFloat(subTotalSum).toFixed(2)) || "0"
        }}</span>
      </v-col>
    </v-row>
    <v-row no-gutters class="mt-4 mr-9">
      <v-col cols="9" class="text-right helvetica-medium fs-20"></v-col>
      <v-col cols="3" class="text-right fs-16" :class="currentLocale === 'ru' ? 'helvetica-medium' : 'rubik-medium'">
        <a
          class="fz-16 tes-blue-text link-no-text-decoration"
          @click="getExcelFile"
          >{{$t('pages.historySpdDetails.downloadExcel')}}</a
        >
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";

import PersonalAccountSelect from "@/components/common/PersonalAccountSelect";
import VTableWrapper from "@/components/wrapper/VTableWrapper";
import LoaderWrapper from "@/components/common/LoaderWrapper";

const b64toBlob = (b64Data, contentType = "", sliceSize = 512) => {
  const byteCharacters = atob(b64Data);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);

    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }

  const blob = new Blob(byteArrays, {
    type: contentType,
  });
  return blob;
};

export default {
  components: {
    PersonalAccountSelect,
    VTableWrapper,
    LoaderWrapper,
  },
  layout: "main",
  data: () => ({
    month: null,
    year: null,
    loading: false,
    windowSize: {
      x: 0,
      y: 0,
    },
  }),
  computed: {
    ...mapState("account", ["selectedAccount"]),
    ...mapState("payments", ["recieptDocument"]),
    ...mapGetters("locale",["currentLocale"]),

    subTotalSum() {
      return this.recieptDocument.reduce((sum, item) => sum + item.toPay, 0);
    },
    headers() {
      return [
      {
        text: this.$t('pages.historySpdDetails.name'),
        value: "serviceName",
        isResizable: true,
      },
      {
        text: this.$t('pages.historySpdDetails.code'),
        value: "codePrincipal",
      },
      {
        text: this.$t('pages.historySpdDetails.measure'),
        value: "measure",
        isResizable: true,
      },
      {
        text: this.$t('pages.historySpdDetails.debt'),
        value: "dolg",
      },
      {
        text: this.$t('pages.historySpdDetails.paid'),
        value: "curRepaySum",
      },
      {
        text: this.$t('pages.historySpdDetails.rate'),
        value: "lastMonRate",
      },
      {
        text: "Тариф",
        value: "tariff",
      },
      {
        text: this.$t('pages.historySpdDetails.accrued'),
        value: "accrued",
      },
      {
        text: this.$t('pages.historySpdDetails.boostCoef'),
        value: "boostCoef",
      },
      {
        text: this.$t('pages.historySpdDetails.boostCoefSum'),
        value: "boostCoefSum",
      },
      {
        text: this.$t('pages.historySpdDetails.underdelivery'),
        value: "lastMonNedop",
      },
      {
        text: this.$t('pages.historySpdDetails.recalculation'),
        value: "lastMonReCalc",
      },
      {
        text: this.$t('pages.historySpdDetails.toPay'),
        value: "toPay",
      },
    ]
    }
  },
  created() {
    this.month = this.$route.query.m;
    this.year = this.$route.query.y;

    if (!this.month || !this.year) {
      this.$router.back();
    }

    this.loadDetail();
    this.onResize();
  },

  beforeDestroy() {
    this.$store.commit("payments/SET_RECEIPT_DOCUMENT");
  },
  methods: {
    loadDetail() {
      this.loading = true;
      return this.$store
        .dispatch(`payments/ReceiptsDetails`, {
          domHoz: this.selectedAccount.domHoz,
          month: this.month,
          year: this.year,
        })
        .catch((error) => {
          console.log("error", error);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    getExcelFile() {
      this.loading = true;
      return this.$store
        .dispatch(`payments/DownloadReceiptMonth`, {
          domHoz: this.selectedAccount.domHoz,
          month: this.month,
          year: this.year,
        })
        .then((response) => {
          const link = document.createElement("a");
          const blob = b64toBlob(
            response.data.file,
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          );
          const date = new Date(this.year, this.month - 1);
          const monthName = date.toLocaleString("ru-RU", { month: "long" });

          link.href = URL.createObjectURL(blob);
          link.download = "Квитанция_" + monthName + "_" + this.year + ".xlsx";
          document.body.appendChild(link);
          link.click();
        })
        .finally(() => {
          this.loading = false;
        });
    },

    getDateToLocaleString(m, y) {
      let _d = new Date();

      _d.setMonth(m - 1) && _d.setFullYear(y);

      return _d.toLocaleString(this.currentLocale === 'ru' ? 'ru' : 'tt-RU', {
        month: "long",
        year: "numeric",
      });
    },
    onResize() {
      this.windowSize = {
        x: window.innerWidth,
        y: window.innerHeight,
      };
    },
  },
  filters: {
    capitalize(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
  },
  watch: {
    selectedAccount() {
      this.loadDetail();
    },
  },
};
</script>

<style scoped>
</style>
